import React from 'react';

/**
 * Form layout will properly space multiple inputs inside of a form.
 */
const FormLayout = ({ children, dataMetrics, dataTestId, }) => {
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || "form-layout", className: "tw-space-y-4" }, children));
};

export { FormLayout };
//# sourceMappingURL=FormLayout.esm.js.map
